export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5626.6aae3bd6.jpg";